import { render, staticRenderFns } from "./CleancoffeeDash.vue?vue&type=template&id=3eac3f8a"
import script from "./CleancoffeeDash.vue?vue&type=script&lang=js"
export * from "./CleancoffeeDash.vue?vue&type=script&lang=js"
import style0 from "./CleancoffeeDash.vue?vue&type=style&index=0&id=3eac3f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports